module.exports = __webpack_public_path__ + "img/marc_n.870cb73f.png";